export const common = {
  "cancel": "Cancel",
  "close": "Close",
  "save": "Save",
  "saving": "Saving...",
  "edit": "Edit",
  "delete": "Delete",
  "actions": "Actions",
  "status": "Status",
  "active": "Active",
  "inactive": "Inactive",
  "name": "Name",
  "email": "Email",
  "role": "Role",
  "pin": "PIN",
  "sku": "SKU",
  "price": "Price",
  "stock": "Stock",
  "category": "Category",
  "subtotal": "Subtotal",
  "discount": "Discount",
  "tax": "Tax",
  "total": "Total"
};
